import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-2 bg-gray-50 border border-gray-200 rounded-lg p-3"
}
const _hoisted_2 = { class: "flex items-center gap-2" }

import { computed } from 'vue';
import LlAutocomplete from '@/components/LlAutocomplete.vue';
import LlTextField from '@/components/LlTextField.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlListItem from '@/components/LlListItem.vue';
import type { useVendorSearch } from './useVendorSearch';
import type { VendorData } from '@/models/lienTypes';


export default /*@__PURE__*/_defineComponent({
  __name: 'FeeRecipientVendorPicker',
  props: {
    modelValue: {},
    vendorSearch: {},
    availableVendors: {},
    dataCy: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const selectedLabel = computed(
  () => props.availableVendors.find((v) => v.vendorId === props.modelValue)?.displayName ?? '',
);

const addNewVendorLabel = computed(() => {
  const term = props.vendorSearch.searchTerm.value;
  return term ? `Create New "${term}"` : 'Add New Vendor';
});

/** Creates the vendor inline, then auto-selects it for the caller (mirrors LienFormPanel). */
async function onCreateVendor(): Promise<void> {
  const vendor = await props.vendorSearch.saveNewVendor();
  if (vendor) emit('update:modelValue', vendor.vendorId);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(LlAutocomplete, {
      "model-value": __props.modelValue,
      search: __props.vendorSearch.searchTerm.value,
      items: __props.availableVendors,
      "item-title": "displayName",
      "item-value": "vendorId",
      loading: __props.vendorSearch.vendorsLoading.value,
      placeholder: "Search vendors…",
      "hide-details": "auto",
      clearable: "",
      "data-cy": __props.dataCy,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = (v) => _ctx.$emit('update:modelValue', v ?? null)),
      "onUpdate:search": __props.vendorSearch.search
    }, {
      selection: _withCtx(() => [
        _createTextVNode(_toDisplayString(selectedLabel.value), 1)
      ]),
      "no-data": _withCtx(() => [
        _createVNode(LlListItem, {
          title: __props.vendorSearch.vendorError.value || 'No vendors found',
          color: __props.vendorSearch.vendorError.value ? 'error' : 'muted'
        }, null, 8, ["title", "color"])
      ]),
      "append-item": _withCtx(() => [
        _createVNode(LlListItem, {
          icon: "mdi-plus",
          color: "primary",
          clickable: "",
          title: addNewVendorLabel.value,
          "data-cy": `${__props.dataCy}-add-new-vendor`,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.vendorSearch.openAddVendor()))
        }, null, 8, ["title", "data-cy"])
      ]),
      _: 1
    }, 8, ["model-value", "search", "items", "loading", "data-cy", "onUpdate:search"]),
    (__props.vendorSearch.showAddVendor.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[6] || (_cache[6] = _createElementVNode("label", { class: "text-xs font-medium text-gray-700 mb-1 block" }, [
            _createTextVNode("Display Name "),
            _createElementVNode("span", { class: "font-bold" }, "*")
          ], -1)),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(LlTextField, {
              modelValue: __props.vendorSearch.newVendorName.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((__props.vendorSearch.newVendorName.value) = $event)),
              placeholder: "e.g., Smith & Associates",
              "hide-details": "auto",
              "data-cy": `${__props.dataCy}-new-vendor-name`,
              class: "flex-1"
            }, null, 8, ["modelValue", "data-cy"]),
            _createVNode(LlSecondaryButton, {
              color: "primary",
              loading: __props.vendorSearch.creatingVendor.value,
              "data-cy": `${__props.dataCy}-save-new-vendor`,
              onClick: onCreateVendor
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("Create", -1)
              ]))]),
              _: 1
            }, 8, ["loading", "data-cy"]),
            _createVNode(LlSecondaryButton, {
              "data-cy": `${__props.dataCy}-cancel-new-vendor`,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (__props.vendorSearch.cancelAddVendor()))
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode("Cancel", -1)
              ]))]),
              _: 1
            }, 8, ["data-cy"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})